import { render, staticRenderFns } from "./ViewItemOverlay.vue?vue&type=template&id=185fdc41&scoped=true"
import script from "./ViewItemOverlay.vue?vue&type=script&lang=js"
export * from "./ViewItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ViewItemOverlay.vue?vue&type=style&index=0&id=185fdc41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185fdc41",
  null
  
)

export default component.exports